// extracted by mini-css-extract-plugin
module.exports = {"expanded":"BadgeWithAnnotation__expanded__55t5U"};